/* Keeps the free Chiffon MIROCLEAN gifts in the cart in line with the number of cloths:
   1+ cloth = e-book, 4+ = 2 Mini, 6+ = gant (config in snippets/mc-gifts.liquid). The gift lines are the
   hidden cadeau-* products, made free by the automatic discount "Cadeau offert". Runs after every cart
   change on any page; the theme refreshes the drawer after our own cart calls. */
(() => {
  const node = document.getElementById('mc-gifts-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const gifts = config.gifts.filter(gift => gift.variant);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const json = (path, body) => fetch(root + path, {
    method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
  });

  // extra = cloths about to be added by the offer block
  const plan = (cart, extra = 0) => {
    const cloths = cart.items.filter(item => item.product_id === config.product).reduce((sum, item) => sum + item.quantity, 0) + extra;
    const updates = {};
    const add = [];
    gifts.forEach(gift => {
      const want = cloths >= gift.min ? gift.qty : 0;
      const lines = cart.items.filter(item => item.variant_id === gift.variant);
      lines.forEach((line, n) => {
        const quantity = n === 0 ? want : 0;
        if (line.quantity !== quantity) updates[line.key] = quantity;
      });
      if (want && !lines.length) add.push({id: gift.variant, quantity: want, properties: {_cadeau: '1'}});
    });
    return {updates, add};
  };

  let running = false;
  let queued = false;
  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(sync, 250); };
  async function sync() {
    if (running) { queued = true; return; }
    running = true;
    try {
      const cart = await (await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})).json();
      const next = plan(cart);
      if (Object.keys(next.updates).length) await json('cart/update.js', {updates: next.updates});
      if (next.add.length) await json('cart/add.js', {items: next.add});
    } catch (error) {
      // a failed check is retried on the next cart change
    } finally {
      running = false;
      if (queued) { queued = false; schedule(); }
    }
  }

  window.mcGifts = {plan};
  const CART_CALL = /\/cart\/(add|change|update|clear)(\.js)?$/;
  try {
    new PerformanceObserver(list => {
      if (list.getEntries().some(entry => (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest') &&
        CART_CALL.test(new URL(entry.name, location.href).pathname))) schedule();
    }).observe({type: 'resource', buffered: false});
  } catch (error) {
    // no PerformanceObserver: the check on page load still runs
  }
  schedule();
})();
